/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.6.0-nightly.2026.8.8",
    versionName: "0.6.0-nightly.2026.8.8",
    versionChannel: "nightly",
    buildDate: "2026-08-08T00:14:37.734Z",
    commitHash: "7d1e955e32ffb6ca734b3180658e0db5feabd823",
};
